<ng-container *ngIf="compilation?.projectRemark?.items?.length > 0; else noRemarks">
  <table class="nrk-table" style="width:100%">
    <tr>
      <th *ngIf="!print"><button class="nrk-doc-button" (click)="addRemark()">+</button></th>
      <th>Date</th>
      <th>User</th>
      <th>Category</th>
      <th>Remark</th>
      <th>Upload</th>
      <th *ngIf="!print"></th>
      <th *ngIf="!print"></th>
    </tr>
    <tr *ngFor="let item of filterItems(compilation.projectRemark); let i = index">
      <td *ngIf="!print"><button class="nrk-doc-button" (click)="removeRemark(i)">-</button></td>
      <td>{{ item.date | date : 'yyMMdd' }}</td>
      <td style="text-align:center">{{ item.user }}</td>
      <td *ngIf="print">{{item.category}}</td>
      <td *ngIf="!print">
        <ngx-doc-form-dropdown [(value)]="item.category" [options]="categoryOptions"></ngx-doc-form-dropdown>
        <ngx-doc-form-texfield [(value)]="item.category"></ngx-doc-form-texfield>
      </td>
      <td *ngIf="print" style="width:100%">{{ item.text }}</td>
      <!-- <td *ngIf="!print" style="width:100%"><ngx-doc-form-texfield class="fullwidth" [(value)]="item.text"></ngx-doc-form-texfield></td> -->
      <td *ngIf="!print" style="width:100%"><ngx-form-text [multiline]="1" [(value)]="item.text"></ngx-form-text></td>
      <td style="text-align:center"><i style="cursor:pointer" class="ionicon ion-upload h5" (click)="uploadWin.show()" title="Upload File"></i>
        {{item.files?.length ? '✓' : ''}}
        <nrk-window #uploadWin>
          <nrk-header>File Uploads</nrk-header>
          <nrk-content>
            <ngx-form-upload [fullwidth]="true" [hideComment]="false" [(files)]="item.files" url="/api/v1/upload"></ngx-form-upload>
          </nrk-content>
        </nrk-window>
      </td>
      <td *ngIf="!print">
        <div style="cursor:pointer" title="toggle active" (click)="item.inactive = !item.inactive">{{item.inactive ? '🔴' : '🟢'}}</div>
      </td>
      <td *ngIf="!print && !item.inactive">
        <div *ngIf="i !== 0" style="cursor:pointer" (click)="moveItem(i)">▲</div>
        <div *ngIf="i !== compilation.projectRemark.items.length - 1 " style="cursor:pointer" (click)="moveItem(i, false)">▼</div>
      </td>
    </tr>
  </table>
  <ng-container *ngIf="!print">
    <div class="m-1">
      <ngx-doc-form-checkbox label="Show in project report" [(value)]="compilation.projectRemark.inProjectReport"></ngx-doc-form-checkbox>
    </div>
    <div class="m-1">
      <ngx-doc-form-checkbox label="Show in project overview" [(value)]="compilation.projectRemark.inProjectOverview"></ngx-doc-form-checkbox>
    </div>
  </ng-container>
</ng-container>

<ng-template #noRemarks>
  <button *ngIf="!print" class="nrk-doc-button" (click)="addRemark()">+</button>
</ng-template>

